// Popunder destination templates. A pop campaign sends the user to an
// advertiser/tracker URL (e.g. a Keitaro link) with a closed set of macros
// substituted at the redirect. The macro set is whitelisted so a template can
// never reflect anything but these URL-encoded values into a Location header.
//
// No runtime dependency beyond zod; shared validates the template's shape, the
// backend fills the values.
export const POP_MACROS = [
    "sub_id_1", // our popId (the click id the tracker posts back)
    "zone", // the SSP zone / placement id
    "provider", // our provider uuid
    "campaign", // our campaign uuid
    "cost", // per-visit cost in dollars (basis per campaign `costMacro`)
    "country", // ISO alpha-2
    "os", // device os, lowercased
    "device", // OpenRTB device type int
];
// Any `{…}` token, so `{ClickID}` or `{click-id}` is caught by the whitelist
// check instead of silently reaching the tracker unexpanded.
const MACRO_RE = /\{([^{}]*)\}/g;
const KNOWN = new Set(POP_MACROS);
// Every `{name}` in the template that is not a whitelisted macro, in order of
// first appearance, de-duplicated.
export const findUnknownMacros = (template) => {
    const unknown = [];
    for (const m of template.matchAll(MACRO_RE)) {
        const name = m[1];
        if (!KNOWN.has(name) && !unknown.includes(name))
            unknown.push(name);
    }
    return unknown;
};
// Substitute whitelisted macros with URL-encoded values. A macro with no value
// renders as an empty string; unknown `{…}` tokens are left as they are (the
// schema rejects them at save time, so they never reach a live template).
export const renderPopDestination = (template, values) => template.replace(MACRO_RE, (whole, name) => {
    if (!KNOWN.has(name))
        return whole;
    const v = values[name];
    return v === undefined || v === null ? "" : encodeURIComponent(String(v));
});
//# sourceMappingURL=pop.js.map